export default function createFencesWorker() {
  return new Worker(new URL('./worker.js', import.meta.url));
}
